import React, { useEffect, useState } from 'react';
import { Col, Divider, Input, message, Row, Select, Spin } from 'antd';
import FormInput from 'components/FormInput';
import Form, { FormInstance } from 'antd/lib/form';
import DF from 'DisplayFramework';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import { getProposalById, PropThirdPartyResponse } from 'services/proposal';
import { useQuery } from 'react-query';
import {
  FinConElementResponse,
  getFinContractById,
} from 'services/fincontract';
import { PricingResponse } from 'services/pricing';
import * as finEngine from 'services/finEngine';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import Address from 'components/address';
import Title from 'components/Title';
import InputCurrency from 'components/InputCurrency/InputCurrency';
export type TabContractChangeAddressProps = {
  objectid: number;
  form: FormInstance;
  data: Array<PropThirdPartyResponse>;
  setSuccessful?: any;
};
const TabContractChangeAddress = ({
  objectid,
  form,
  data,
  setSuccessful,
}: TabContractChangeAddressProps) => {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState({
    isLoading: false,
    isModSelected: false,
    newDuration: 0,
    effectDate: '',
    feesAmount: 0,
    feesFormula: '',
    newElements: [] as FinConElementResponse[],
  });

  const { data: contract, isFetching } = useQuery(
    ['getFinContractById', { ctrid: objectid }],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data)
  );

  const { data: proposal, isFetching: isFetch } = useQuery(
    ['getProposalById', { ctrid: objectid }],
    () => getProposalById({ ctrid: objectid }).then((res) => res.data),
    { enabled: !data }
  );

  useEffect(() => {
    const client = contract?.thirdParties.find(
      (e: any) => e.tprolecode === 'CLIENT' && e.status === 'ACTIVE'
    )?.address;
    if (contract) {
      form?.setFieldsValue({
        event: 'tabContractChangeADR',
        rolcode: 'CLIENT',
        Currtpmainadrcountry: client?.tpmainadrcountry,
        Currtpmainadrregion: client?.tpmainadrregion,
        Currtpmainadrcity: client?.tpmainadrcity,
        Currtpmainadrzipcode: client?.tpmainadrzipcode,
        Currtpmainadrstreet1: client?.tpmainadrstreet1,
        Currtpmainadrstreet2: client?.tpmainadrstreet2,
        tpid: client?.tpid,
        currcode: contract.currcode,
      });
    }

    setSuccessful(isFetching && isFetch);
  }, [isFetching, isFetch]);

  const notInvoicedSchedule = contract?.conElements
    ?.find((e) => e.ctetype === 'FIN')
    ?.conElemSchedules.filter((s) => s.ciid === null);
  const offerid = contract?.offerid;

  const optionDates = notInvoicedSchedule?.map((e, index) => (
    <option key={index} value={e.ctsduedate.toString()}>
      {e.ctsduedate}
    </option>
  ));

  const calculateFees = (pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: contract?.conElements[0].conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: contract?.conElements[0].ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.conElements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: contract?.conElements[0].cteduration ?? 0,
          inInvestAmount: contract?.conElements[0].cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0].assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: form?.getFieldValue('effectDate'),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          form?.setFieldsValue({
            feesAmount: res.installmentamount,
            feesTax: (res.installmentamount * (pricing?.taxrate ?? 0)) / 100,
            feesTaxcode: pricing?.taxcode,
            feesTaxrate: pricing?.taxrate,
            feestype: pricing?.ctetype,
            feescategory: pricing?.ctecategory,
            feesFormula: pricing?.priid,
          });
        }
      });
  };

  return (
    <DF.Provider pagcode="TabTPAddress">
      <Spin spinning={isFetching}>
        <Row gutter={16}>
          <FormInput col xs={6} name="affectDate">
            <Select
              defaultValue=""
              style={{ width: '100%' }}
              disabled={state.isModSelected}
            >
              {optionDates}
            </Select>
          </FormInput>
        </Row>

        <Divider orientation="left">
          {' '}
          <Title comcode="addressToReplace" level={5} />
        </Divider>
        <Row gutter={20}>
          <Col lg={10}>
            <FormInput name="Currtpmainadrstreet1">
              <Input disabled />
            </FormInput>
          </Col>
          <Col lg={10}>
            <FormInput name="Currtpmainadrstreet2">
              <Input disabled />
            </FormInput>
          </Col>
        </Row>
        <Row gutter={16}>
          <Address
            form={form}
            paysField="Currtpmainadrcountry"
            regionField="Currtpmainadrregion"
            villeField="Currtpmainadrcity"
            codePostalField="Currtpmainadrzipcode"
            spanGlobalRegion={6}
            disabled
          />
        </Row>

        <Divider orientation="left">
          <Title comcode="newAddressDetail" level={5} />
        </Divider>
        <Row gutter={16}>
          <Col xs={5}>
            <Form.Item shouldUpdate={() => true} noStyle>
              {({ getFieldValue }) => {
                const tpid = getFieldValue('tpid');

                return (
                  <FormInput name="tpadrid">
                    <AddresseListSelect
                      params={{ tpid: tpid ?? 0 }}
                      onSelected={(e) =>
                        form?.setFieldsValue({
                          tpmainadrcountry: e.tpmainadrcountry,
                          tpmainadrregion: e.tpmainadrregion,
                          tpmainadrcity: e.tpmainadrcity,
                          tpmainadrzipcode: e.tpmainadrzipcode,
                          tpmainadrstreet1: e.tpmainadrstreet1,
                          tpmainadrstreet2: e.tpmainadrstreet2,
                          feestype: '',
                          feesTaxrate: 0,
                          feesTaxcode: '',
                          feescategory: '',
                          feesFormula: '' as any,
                          feesAmount: 0,
                        })
                      }
                    />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <FormInput col xs={10} name="tpmainadrstreet1">
            <Input disabled />
          </FormInput>

          <FormInput col xs={10} name="tpmainadrstreet2">
            <Input disabled />
          </FormInput>

          <Address
            form={form}
            paysField="tpmainadrcountry"
            regionField="tpmainadrregion"
            villeField="tpmainadrcity"
            codePostalField="tpmainadrzipcode"
            spanGlobalRegion={6}
            disabled
          />
        </Row>
        <Divider orientation="left">
          {' '}
          <Title comcode="fees" level={5} />
        </Divider>
        <Row gutter={16}>
          <FormInput col xs={12} name="feesFormula">
            <PricingListFilteredSelect
              allowClear
              disabled={state.isModSelected}
              params={{
                offerid: offerid ?? 0,
                ctetype: 'MODFEES', // Modifictaion fees
                prcode: contract?.prcode ?? '',
                entity: '',
                entityid: 0,
                tpid: contract?.tpidclient ?? 0,
              }}
              onChange={(e) => {
                calculateFees(e);
              }}
              onClear={() => {
                form.setFieldValue('feesAmount', 0);
              }}
            />
          </FormInput>
          <FormInput col xs={12} name="feesAmount" shouldUpdate>
            <InputCurrency
              defaultValue={0}
              disabled={
                state.isModSelected ||
                form.getFieldValue('feesFormula') === undefined ||
                form.getFieldValue('feesFormula') === 0
              }
              currcode={form.getFieldValue('currcode')}
            />
          </FormInput>
          {/* <FormInput col xs={12} name="feesTax">
          <Input />
        </FormInput> */}

          {/* <FormInput col xs={12} name="feesTaxcode" hidden>
            <Input />
          </FormInput>
          <FormInput col xs={12} name="feesTaxrate" hidden>
            <Input />
          </FormInput>
          <FormInput col xs={12} name="feestype" hidden>
            <Input />
          </FormInput>
          <FormInput col xs={12} name="feescategory" hidden>
            <Input />
          </FormInput> */}
        </Row>
      </Spin>
    </DF.Provider>
  );
};

export default TabContractChangeAddress;
